import React, { useContext, useEffect, useState } from "react"
import GameContext from "../../../Context/GameContext"
import { actions } from "../../shared/constants"
import { createHostAction } from "../createHostAction"
import { Slides } from "../slides/Slides"
import { defaultLabels } from "../../shared/defaultLabels"
import { fallbackContent } from "../../shared/fallbackContent"

export const GlobalOutro = props => {
  const { gameData, onAction } = useContext(GameContext)

  const handleEnd = () => {
    onAction(createHostAction(actions.HOST_END_GAME))
    sessionStorage.clear()
    window.location.reload()
  }

  const [content, setContent] = useState([])

  useEffect(() => {
    const content =
      gameData?.game_outro?.host_outro_slides ||
      fallbackContent.game_outro.host_outro_slides
    content.push({
      title:
        gameData?.game_outro?.host_results_title ||
        fallbackContent.game_outro.host_results_title,
      type: "game-outro-results",
    })
    setContent(content)
  }, [gameData])

  const previous =
    gameData?.game_defaults?.host_previous_button ||
    defaultLabels?.GAME_DEFAULTS_HOST_PREVIOUS_BUTTON

  const next =
    gameData?.game_defaults?.host_next_button ||
    defaultLabels?.GAME_DEFAULTS_HOST_NEXT_BUTTON

  const end =
    gameData?.game_outro?.host_end_game_button ||
    defaultLabels?.GAME_OUTRO_END_GAME_BUTTON

  const backgroundImage = gameData?.game_outro?.host_background_image || null

  return (
    <Slides
      content={content}
      labels={{
        previous,
        next,
        end,
      }}
      handleEnd={handleEnd}
      backgroundImage={backgroundImage}
    />
  )
}
